import { Compass } from "lucide-react";
import { useLocation, useNavigate } from "react-router";

import { AppShell } from "@/components/layout/AppShell";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/Button";
import { EmptyState } from "@/components/ui/EmptyState";
import { useT } from "@/lib/i18n";

export function NotFoundPage() {
  const navigate = useNavigate();
  const t = useT();
  const location = useLocation();
  return (
    <AppShell>
      <Seo
        description={t("notFound.body")}
        noindex
        path={location.pathname}
        title={t("notFound.title")}
      />
      <EmptyState
        action={<Button onClick={() => void navigate("/")}>{t("notFound.home")}</Button>}
        description={t("notFound.body")}
        icon={Compass}
        title={t("notFound.title")}
      />
    </AppShell>
  );
}
